export const environment = {
    production: false,
    apiLink: 'https://clockload-api.dev.sla03.devtest.aws.scania.com/api',
    redirectUri: "https://clockload.dev.sla03.devtest.aws.scania.com",
    protectedResource: 'api://acd69533-1b29-465c-acaf-2edb9e630f3f/user.read'
};